<template>
  <div v-if="item">
    <div v-if="dateTime.includes(column.key) || column.key.endsWith('_at')"> {{  $filters.date(item[column.key], 1) }}</div>
    <div v-else-if="amounts.includes(column.key)">
        {{ $filters.number_format(item[column.key],2) }}
    </div>
    <div v-else-if="dates.includes(column.key)">
        {{ $filters.date(item[column.key]) }}
    </div>
    <div v-else-if="booleans.includes(column.key)">
        <span v-if="item[column.key] === true || item[column.key] === 1" class="badge bg-primary">YES</span>
        <span v-else class="badge bg-danger">NO</span>
    </div>
    <div v-else-if="numbers.includes(column.key) || column.key.endsWith('_count')">
        {{ $filters.number_format(item[column.key],0) }}
    </div>
    <div v-else-if="statuses.includes(column.key) || column.key.endsWith('_status')"><span v-html="statusBadge(item[column.key])"></span></div>
    <div v-else>{{ item[column.key] }}</div>
  </div>
</template>

<script>
export default {
    props:{
        item: {
            type: Object,
            default: null
        },
        column:{
            type: Object,
            required: true
        }
    },
    data(){
        return{
            dates: ['date', 'user_date_of_birth', 'date_of_birth', 'start_date', 'end_date', 'effective_date'],
            amounts: ['allowance_amount','deduction_amount','amount', 'basic_salary',
                     'balance', 'step_level_basic_salary', 'monthly_deduction', 'tax', 'nhf',
                     'basic_incremental_rate', 'gross_pay', 'net_pay', 'total_allowances',
                     'total_deductions', 'arrears', 'loan_repayment', 'accumulated_amount',
                     'amount_carried_forward'],
            dateTime: ['created_at', 'updated_at', 'started_at', 'completed_at'],
            booleans: [
                'is_active', 'deduction_is_statutory', 'is_primary', 'disabled_nhf',
                'is_highest', 'is_next_of_kin', 'has_financial_right', 'is_statutory', 'is_political',
                'all_verification_passed', 'manual_check_passed', 'min_verification_passed'
            ],
            statuses: ['status'],
            numbers: []
        }
    }
}
</script>

<style>

</style>